import { RaidPlanAssignmentEntity } from 'app/frontend/types/custom/RaidPlan'

const getAssignmentEntityIdentity = (entity: RaidPlanAssignmentEntity) => {
  if (entity.kind === 'member') return `member:${entity.character_id}`
  if (entity.kind === 'collection') return `collection:${entity.collection}`
  if (entity.kind === 'group') return `group:${entity.group}`
  if (entity.kind === 'by_role') return `by_role:${entity.role}`
  if (entity.kind === 'by_class') return `by_class:${entity.class_id}`
  if (entity.kind === 'role') return `role:${entity.role}`
  return 'everyone'
}

export default getAssignmentEntityIdentity
